'use strict';

import router from '../../router';

// initial state
const state = {
    visible: false,
    timezone: null,
    culture: null,
    errors: {}
};

// mutations
const mutations = {
    errors(state, errors) {
        state.errors = errors;
    },
    open(state) {
        state.visible = true;
    },
    close(state) {
        state.visible = false;
        state.errors = {};
    },
    //setters
    timezone(state, value) {
        state.timezone = value;
    },
    culture(state, value) {
        state.culture = value;
    }
};

// getters
const getters = {
};

// actions
const actions = {
    open(store) {
        store.commit('timezone', store.rootState.settings.account.timezone);
        store.commit('culture', store.rootState.settings.account.culture);
        store.commit('open');
    },
    close(store) {
        store.commit('close');
    },
    save(store) {
        store.dispatch('settings/save',
            {
                timezone: store.state.timezone,
                culture: store.state.culture
            },
            { root: true });
        store.commit('close');
        router.go();
    },
    confirmSignout(store) {
        store.dispatch('confirmation/open',
            {
                title: 'CONFIGURATION__CONFIRM_SIGNOUT',
                handlerAction: 'configuration/signout',
                handlerActionParams: null
            },
            { root: true });
    },
    signout(store) {
        store.commit('close');
        store.dispatch('settings/signout', null, { root: true });
    },
    //setters
    setTimezone(store, value) {
        store.commit('timezone', value);
    },
    setCulture(store, value) {
        store.commit('culture', value);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/configuration.js